module.exports = __webpack_public_path__ + "img/17_75.7f645548.png";